﻿$(document).ready(function() {
	
	//$flightList = $("[gr=a]");

	//BEGIN - Declare Sliders
	
	//SLIDER #1
	$("#slider-range1").slider({
		range: true,
		min: 0,
		max: 24,
		values: [ 0, 24 ],
		slide: function(event, ui) {
			if(parseInt(ui.values[0]) < 10 && parseInt(ui.values[1]) < 10) {
				$("#dprDepartureTimes").val("0" + ui.values[0] + ":00 - 0" + ui.values[1] + ":00");
			} else if(parseInt(ui.values[0]) < 10 && parseInt(ui.values[1]) >= 10) {
				$("#dprDepartureTimes").val("0" + ui.values[0] + ":00 - " + ui.values[1] + ":00");
			} else if(parseInt(ui.values[0]) >= 10 && parseInt(ui.values[1]) < 10) {
				$("#dprDepartureTimes").val(ui.values[0] + ":00 - 0" + ui.values[1] + ":00");
			} else {
				$("#dprDepartureTimes").val(ui.values[0] + ":00 - " + ui.values[1] + ":00");
			}
		}
	});
	
	
	if(parseInt($("#slider-range1").slider("values", 0)) < 10) {
		$("#dprDepartureTimes").val("0" + $("#slider-range1").slider("values", 0) + ":00 - " + $("#slider-range1").slider("values", 1) + ":00");
	} else {
		$("#dprDepartureTimes").val($("#slider-range1").slider("values", 0) + ":00 - " + $("#slider-range1").slider("values", 1) + ":00");
	}
	
	$("#slider-range1").slider({change: function(event, ui) {
		
		if($(this).data("noFiltering") == true){
			return;
		}
		
		searchFilter();
		$('#resetFilterTimeDpr').show();
	}});
	
	//SLIDER #2
	$("#slider-range2").slider({
		range: true,
		min: 0,
		max: 24,
		values: [ 0, 24 ],
		slide: function(event, ui) {
			
			if(parseInt(ui.values[0]) < 10 && parseInt(ui.values[1]) < 10) {
				$("#dprArrivalTimes").val("0" + ui.values[0] + ":00 - 0" + ui.values[1] + ":00");
			} else if(parseInt(ui.values[0]) < 10 && parseInt(ui.values[1]) >= 10) {
				$("#dprArrivalTimes").val("0" + ui.values[0] + ":00 - " + ui.values[1] + ":00");
			} else if(parseInt(ui.values[0]) >= 10 && parseInt(ui.values[1]) < 10) {
				$("#dprArrivalTimes").val(ui.values[0] + ":00 - 0" + ui.values[1] + ":00");
			} else {
				$("#dprArrivalTimes").val(ui.values[0] + ":00 - " + ui.values[1] + ":00");
			}
		}
	});
	
	if(parseInt($("#slider-range2").slider("values", 0)) < 10) {
		$("#dprArrivalTimes").val("0" + $("#slider-range2").slider("values", 0) + ":00 - " + $("#slider-range2").slider("values", 1) + ":00");
	} else {
		$("#dprArrivalTimes").val($("#slider-range2").slider("values", 0) + ":00 - " + $("#slider-range2").slider("values", 1) + ":00");
	}
	
	$("#slider-range2").slider({change: function(event, ui) {
		
		if($(this).data("noFiltering") == true){
			return;
		}
		
		searchFilter();
		$('#resetFilterTimeDpr').show();
		
	}});
	//SLIDER #5
	var travelTimesDep = getTravelTimes($("[gr=a]"), "departure"); 
	var minTravelTimeDep = Math.min.apply(Math, travelTimesDep);
	var maxTravelTimeDep = Math.max.apply(Math, travelTimesDep);
	
	
	$("#slider-range5").slider({
		range: true,
		min: minTravelTimeDep,
		max: maxTravelTimeDep,
		values: [ minTravelTimeDep, maxTravelTimeDep ],
		step: 10,
		slide: function(event, ui) {
			
			var minMinute = ui.values[0] % 60;
			var minHour =(ui.values[0] - minMinute) / 60;
			
			var maxMinute = ui.values[1] % 60;
			var maxHour =(ui.values[1] - maxMinute) / 60;
			
			$("#travelTimesDep").val(minHour + " "+ FmtMessage.getMessage('js.travel.hour') + " "+ minMinute + " "+ FmtMessage.getMessage('js.travel.minute')+"-" 
					+maxHour + " "+ FmtMessage.getMessage('js.travel.hour') + " "+ maxMinute + " "+ FmtMessage.getMessage('js.travel.minute'));
		}
	});
	
	if(minTravelTimeDep > 0 && maxTravelTimeDep > 0){
		writeSliderValues(minTravelTimeDep, maxTravelTimeDep,"departure");
	}
	
	$("#slider-range5").slider({change: function(event, ui) {
		
		if($(this).data("noFiltering") == true){
			return;
		}
		
		searchFilter();
		$('#resetFilterTimeDpr').show();
	}});
	
	
	//RETURN FLIGHTS
	if($("#returnDate").val() != null && $("#returnDate").val().length > 1) {
		
		
		//SLIDER #3
		$("#slider-range3").slider({
			range: true,
			min: 0,
			max: 24,
			values: [ 0, 24 ],
			slide: function(event, ui) {
				
				if(parseInt(ui.values[0]) < 10 && parseInt(ui.values[1]) < 10) {
					$("#rtnDepartureTimes").val("0" + ui.values[0] + ":00 - 0" + ui.values[1] + ":00");
				} else if(parseInt(ui.values[0]) < 10 && parseInt(ui.values[1]) >= 10) {
					$("#rtnDepartureTimes").val("0" + ui.values[0] + ":00 - " + ui.values[1] + ":00");
				} else if(parseInt(ui.values[0]) >= 10 && parseInt(ui.values[1]) < 10) {
					$("#rtnDepartureTimes").val(ui.values[0] + ":00 - 0" + ui.values[1] + ":00");
				} else {
					$("#rtnDepartureTimes").val(ui.values[0] + ":00 - " + ui.values[1] + ":00");
				}
			}
		});
		
		if(parseInt($("#slider-range3").slider("values", 0)) < 10) {
			$("#rtnDepartureTimes").val("0" + $("#slider-range3").slider("values", 0) + ":00 - " + $("#slider-range3").slider("values", 1) + ":00");
		} else {
			$("#rtnDepartureTimes").val($("#slider-range3").slider("values", 0) + ":00 - " + $("#slider-range3").slider("values", 1) + ":00");
		}
		
		$("#slider-range3").slider({change: function(event, ui) {
			
			if($(this).data("noFiltering") == true){
				return;
			}
			
			searchFilter();
			$('#resetFilterTimeRtn').show();
			
		}});
		
		//SLIDER #4
		$("#slider-range4").slider({
			range: true,
			min: 0,
			max: 24,
			values: [ 0, 24 ],
			slide: function(event, ui) {
				
				if(parseInt(ui.values[0]) < 10 && parseInt(ui.values[1]) < 10) {
					$("#rtnArrivalTimes").val("0" + ui.values[0] + ":00 - 0" + ui.values[1] + ":00");
				} else if(parseInt(ui.values[0]) < 10 && parseInt(ui.values[1]) >= 10) {
					$("#rtnArrivalTimes").val("0" + ui.values[0] + ":00 - " + ui.values[1] + ":00");
				} else if(parseInt(ui.values[0]) >= 10 && parseInt(ui.values[1]) < 10) {
					$("#rtnArrivalTimes").val(ui.values[0] + ":00 - 0" + ui.values[1] + ":00");
				} else {
					$("#rtnArrivalTimes").val(ui.values[0] + ":00 - " + ui.values[1] + ":00");
				}
			}
		});
		
		if(parseInt($("#slider-range4").slider("values", 0)) < 10) {
			$("#rtnArrivalTimes").val("0" + $("#slider-range4").slider("values", 0) + ":00 - " + $("#slider-range4").slider("values", 1) + ":00");
		} else {
			$("#rtnArrivalTimes").val($("#slider-range4").slider("values", 0) + ":00 - " + $("#slider-range4").slider("values", 1) + ":00");
		}
		
		$("#slider-range4").slider({change: function(event, ui) {
			
			if($(this).data("noFiltering") == true){
				return;
			}
			
			searchFilter();
			$('#resetFilterTimeRtn').show();
			
		}});
		

		$("#returnLayover").show();
		$("#return-times").show();	//show departure flights
	}
	
	
	//SLIDER #6
	var travelTimesRet = getTravelTimes($("[gr=a]"), "return"); 
	var minTravelTimeRet = Math.min.apply(Math, travelTimesRet);
	var maxTravelTimeRet = Math.max.apply(Math, travelTimesRet);
	
	
	$("#slider-range6").slider({
		range: true,
		min: minTravelTimeRet,
		max: maxTravelTimeRet,
		values: [ minTravelTimeRet, maxTravelTimeRet ],
		step: 10,
		slide: function(event, ui) {
			
			var minMinute = ui.values[0] % 60;
			var minHour =(ui.values[0] - minMinute) / 60;
			
			var maxMinute = ui.values[1] % 60;
			var maxHour =(ui.values[1] - maxMinute) / 60;
			
			$("#travelTimesReturn").val(minHour + " "+ FmtMessage.getMessage('js.travel.hour') + " "+ minMinute + " "+ FmtMessage.getMessage('js.travel.minute')+"-" 
					+maxHour + " "+ FmtMessage.getMessage('js.travel.hour') + " "+ maxMinute + " "+ FmtMessage.getMessage('js.travel.minute'));
		}
	});
	
	if(minTravelTimeRet > 0 && maxTravelTimeRet > 0){
		writeSliderValues(minTravelTimeRet, maxTravelTimeRet,"return");
	}
	
	$("#slider-range6").slider({change: function(event, ui) {
		
		if($(this).data("noFiltering") == true){
			return;
		}
		
		searchFilter();
		$('#resetFilterTimeRtn').show();
	}});
	
	
	//END - Declare Sliders
	
	
	//Create Airlines Airports And Class Filter
	createAirlinesAirportsClassFiler();

	$(".searchDepAirport:checkbox").on("click", function(){
		searchFilter();
		$('#resetFilterAirport').show();
	});

	$(".searchArrAirport:checkbox").on("click", function(){
		searchFilter();
		$('#resetFilterAirport').show();
	});
	
 	$(".searchStopAirport:checkbox").on("click", function(){
 		searchFilter();
 		$('#resetFilterAirport').show();
 	});
 	
	$(".searchFilterAirline:checkbox").on("click", function(){
		searchFilter();
		$('#resetFilterAirline').show();
	});
	
	$(".searchClassFilter:checkbox").on("click", function(){
		searchFilter();
		$('#resetFilterClass').show();
	});

	$(".depBaggageAllowance:checkbox").on("click", function(){
		searchFilter();
		$('#resetFilterClass').show();
	});

	$(".retBaggageAllowance:checkbox").on("click", function(){
		searchFilter();
		$('#resetFilterClass').show();
	});

	$(".pop-sorting-close").on("click", function(){
		$('.pop-sorting').hide();
	});
	
});


function createAirlinesAirportsClassFiler() {
	
	//set readonly when airport count one
	if($(".searchDepAirport").length == 1) {
		$('.searchDepAirport').attr('readonly',true);
		$('.searchDepAirport').attr("disabled", "disabled");
	}
	
	if($(".searchArrAirport").length == 1) {
		$('.searchArrAirport').attr('readonly',true);
		$('.searchArrAirport').attr("disabled", "disabled");
	}
	
	//hide unnecessary layover checkbox
	if($(".infotranfercount[infooverlaycount=0]").length == 0) {
		$("#loyover0").hide();
	}
	if($(".infotranfercount[infooverlaycount=1]").length == 0) {
		$("#loyover1").hide();
	}
	if($(".infotranfercount[infooverlaycount=2]").length == 0) {
		$("#loyover2").hide();
	}
	
	if($(".infotranfercount[inforeturnoverlaycount=0]").length == 0) {
		$("#rLoyover0").hide();
	}
	if($(".infotranfercount[inforeturnoverlaycount=1]").length == 0) {
		$("#rLoyover1").hide();
	}
	if($(".infotranfercount[inforeturnoverlaycount=2]").length == 0) {
		$("#rLoyover2").hide();
	}

}

function filterByTransfer(transferCount) {
	searchFilter();
	$('#resetFilterLayover').show();
}

function filterByReturnTransfer(transferCount) {
	searchFilter();
	$('#resetFilterReturnLayover').show();
}

function filterByBaggage(amount, type, allowBaggage) {
	searchFilter();
}

function searchFilter() {

	openLoaderBox();
	
	$flightList.attr("data-visible","true");
	$flightListDep.attr("data-visible","true");
	$flightListRet.attr("data-visible","true");
		
	applySearchFilter();
	
	if($(".departureFlight:checked").length > 0){
		
		 $("[gr=a]").has(".departureFlight:not(:checked)").next().andSelf().attr("data-visible","false");
		
	}
	
	if($(".returnFlight:checked").length > 0){
		
		 $("[gr=a]").has(".returnFlight:not(:checked)").next().andSelf().attr("data-visible","false");
		
	}
	pageIndex = 0;
	refreshTable();
	refreshTable2();
	closeLoaderBox();
}

function getTravelTimes(flights, flightType){
	
	var travelTimes = [];
	
	$.each( flights, function( key, flight ) {
		 if(flight.getAttribute("flighttime") > 0 && (flight.getAttribute("flighttype") == flightType || flight.getAttribute("flighttype") == null)){
			 travelTimes.push(flight.getAttribute("flighttime"));
		    }
		});
	return travelTimes;
	
}; 

function applySearchFilter(){
	
	if (!$('#filterByTransfer0').is(':checked')) {
		$flightList.filter("[tranferCount='0']").next().andSelf().attr("data-visible","false");
		$flightListDep.filter("[tranferCount='0']").next().andSelf().attr("data-visible","false");
		
	}
	
	if (!$('#filterByTransfer1').is(':checked')) {
		$flightList.filter("[tranferCount='1']").next().andSelf().attr("data-visible","false");
		$flightListDep.filter("[tranferCount='1']").next().andSelf().attr("data-visible","false");
	}
	
	if (!$('#filterByTransfer2').is(':checked')) {
		$flightList.filter("[tranferCount='2']").next().andSelf().attr("data-visible","false");
		$flightListDep.filter("[tranferCount='2']").next().andSelf().attr("data-visible","false");
	}
	
	if (!$('#filterByReturnTransfer0').is(':checked')) {
		$flightList.filter("[returnTranferCount='0']").next().andSelf().attr("data-visible","false");
		$flightListRet.filter("[tranferCount='0']").next().andSelf().attr("data-visible","false");
	}
	
	if (!$('#filterByReturnTransfer1').is(':checked')) {
		$flightList.filter("[returnTranferCount='1']").next().andSelf().attr("data-visible","false");
		$flightListRet.filter("[tranferCount='1']").next().andSelf().attr("data-visible","false");
	}
	
	if (!$('#filterByReturnTransfer2').is(':checked')) {
		$flightList.filter("[returnTranferCount='2']").next().andSelf().attr("data-visible","false");
		$flightListRet.filter("[tranferCount='2']").next().andSelf().attr("data-visible","false");
	}
	
	$("input.searchDepAirport:not(:checked)").each(function(index) {
		$flightList.filter("[fdepairportname='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
		$flightListDep.filter("[fdepairportname='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
		$flightListRet.filter("[farrairportname='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
	});
	
	
	$("input.searchArrAirport:not(:checked)").each(function(index) {
		$flightList.filter("[farrairportname='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
		$flightListDep.filter("[farrairportname='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
		$flightListRet.filter("[fdepairportname='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
	});
	
 	$("input.searchStopAirport:not(:checked)").each(function(index) {
 		$flightList.filter("[stopAirportNames*='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
 		$flightListDep.filter("[stopAirportNames*='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
 		$flightListRet.filter("[stopAirportNames*='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
 	});
 	
	$("input.searchFilterAirline:not(:checked)").each(function(index) {
		$flightList.filter("[airlinename='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
		$flightListDep.filter("[airlinename='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
		$flightListRet.filter("[airlinename='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
	});
	
	$("input.searchClassFilter:not(:checked)").each(function(index) {
		$flightList.has("[fclass='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
		$flightListDep.has("[fclass='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
		$flightListRet.has("[fclass='" + $(this).val() + "']").next().andSelf().attr("data-visible","false");
	});

	$("input.depBaggageAllowance:not(:checked)").each(function(index) {
		var baggageAmount = $(this).attr("baggageAmount");
		var baggageType = $(this).attr("baggageType");
		$flightList.filter("[baggageAmount='" + baggageAmount + "'][baggageType='" + baggageType + "']").next().andSelf().attr("data-visible","false");
		$flightListDep.filter("[baggageAmount='" + baggageAmount + "'][baggageType='" + baggageType + "']").next().andSelf().attr("data-visible","false");
	});

	$("input.retBaggageAllowance:not(:checked)").each(function(index) {
		var baggageAmount = $(this).attr("baggageAmount");
		var baggageType = $(this).attr("baggageType");
		$flightListRet.filter("[baggageAmount='" + baggageAmount + "'][baggageType='" + baggageType + "']").next().andSelf().attr("data-visible","false");
	});

	var values1 = $("#slider-range1").slider("option", "values");
	filterSliderDepartureDepTime(values1[0], values1[1]);


	var values2 = $("#slider-range2").slider("option", "values");
	filterSliderDepartureArrTime(values2[0], values2[1]);
	
	var values5 = $("#slider-range5").slider("option", "values");
	filterSliderTravelTimesDep(values5[0], values5[1]);


	if ($flightListRet.size() > 0) {
		var values3 = $("#slider-range3").slider("option", "values");
		filterSliderReturnDepTime(values3[0], values3[1]);
		
		var values4 = $("#slider-range4").slider("option", "values");
		filterSliderReturnArrTime(values4[0], values4[1]);
		
		var values6 = $("#slider-range6").slider("option", "values");
		filterSliderTravelTimesReturn(values6[0], values6[1]);
	}
	
	
	clearResultsIfOppositeFlightResultEmpty();	
	
	$( document ).trigger( "flight_filter_event");
}

//Don't want to display only departure or return flights if other side is empty.
function clearResultsIfOppositeFlightResultEmpty(){
	
	var depLength = $flightListDep.filter("[data-visible=true]").length;
	var retLength = $flightListRet.filter("[data-visible=true]").length;

	if(depLength == 0 && retLength == 0) return;//return if one way

	if(depLength == 0){
		$flightListRet.filter("[data-visible=true]").next().andSelf().attr("data-visible","false");
	}
	if(retLength == 0){
		$flightListDep.filter("[data-visible=true]").next().andSelf().attr("data-visible","false");
	}
}

function filterSliderDepartureDepTime(minHour, maxHour) {

	$flightList.each(filterSliderDepartureDepTimeList(minHour, maxHour));	
	$flightListDep.each(filterSliderDepartureDepTimeList(minHour, maxHour));	
	
}

function filterSliderDepartureDepTimeList(minHour, maxHour) {
	return function(index){
		var fdepdate = parseInt($(this).attr("fdepdate").substring(0,2));
	
		if(!isNaN(fdepdate) && fdepdate == 0)
			fdepdate = parseInt($(this).attr("fdepdate").substring(1,2));
		
		if(!isNaN(fdepdate)) {
			
			var chkMinute = parseInt($(this).attr("fdepdate").substring(3,5));									//check minute
			if(chkMinute > 0 && fdepdate < parseInt(minHour - 1) || fdepdate > parseInt(maxHour + 1)) {			//check minute
				$(this).next().andSelf().attr("data-visible","false");
			} else if(fdepdate < parseInt(minHour) || fdepdate > parseInt(maxHour)) {
				$(this).next().andSelf().attr("data-visible","false");
			}
		}
	}
}

function filterSliderDepartureArrTime(minHour, maxHour) {

	$flightList.each(filterSliderDepartureArrTimeList(minHour, maxHour));
	$flightListDep.each(filterSliderDepartureArrTimeList(minHour, maxHour));
	
}

function filterSliderTravelTimesDep(minHour, maxHour) {
	$flightList.each(filterSliderTravelTimesList(minHour, maxHour));
	$flightListDep.each(filterSliderTravelTimesList(minHour, maxHour));
}

function filterSliderTravelTimesReturn(minHour, maxHour) {

	$flightListRet.each(filterSliderTravelTimesList(minHour, maxHour));
}

function writeSliderValues(minTravelTime, maxTravelTime, flightType){
	var minMinute = minTravelTime % 60;
	var minHour =(minTravelTime - minMinute) / 60;
	var maxMinute = maxTravelTime % 60;
	var maxHour =(maxTravelTime - maxMinute) / 60;
	if(flightType =="departure"){
		if(minMinute > 0 &&  maxMinute > 0){
			$("#travelTimesDep").val(minHour + " "+ FmtMessage.getMessage('js.travel.hour') + " "+ minMinute + " "+ FmtMessage.getMessage('js.travel.minute')+"  -  " 
					+maxHour + " "+ FmtMessage.getMessage('js.travel.hour') + " "+ maxMinute + " "+ FmtMessage.getMessage('js.travel.minute'));
		}else if(minMinute > 0 &&  maxMinute == 0){
			$("#travelTimesDep").val(minHour + " "+ FmtMessage.getMessage('js.travel.hour') + " "+ minMinute + " "+ FmtMessage.getMessage('js.travel.minute')+"  -  " 
					+maxHour + " "+ FmtMessage.getMessage('js.travel.hour'));
		}else if(minMinute == 0 &&  maxMinute > 0){
			$("#travelTimesDep").val(minHour + " "+ FmtMessage.getMessage('js.travel.hour') +"  -  " 
					+maxHour + " "+ FmtMessage.getMessage('js.travel.hour')+ " "+ maxMinute + " "+ FmtMessage.getMessage('js.travel.minute'));
		}
	}else{
		if(minMinute > 0 &&  maxMinute > 0){
			$("#travelTimesReturn").val(minHour + " "+ FmtMessage.getMessage('js.travel.hour') + " "+ minMinute + " "+ FmtMessage.getMessage('js.travel.minute')+"  -  " 
					+maxHour + " "+ FmtMessage.getMessage('js.travel.hour') + " "+ maxMinute + " "+ FmtMessage.getMessage('js.travel.minute'));
		}else if(minMinute > 0 &&  maxMinute == 0){
			$("#travelTimesReturn").val(minHour + " "+ FmtMessage.getMessage('js.travel.hour') + " "+ minMinute + " "+ FmtMessage.getMessage('js.travel.minute')+"  -  " 
					+maxHour + " "+ FmtMessage.getMessage('js.travel.hour'));
		}else if(minMinute == 0 &&  maxMinute > 0){
			$("#travelTimesReturn").val(minHour + " "+ FmtMessage.getMessage('js.travel.hour') +"  -  " 
					+maxHour + " "+ FmtMessage.getMessage('js.travel.hour')+ " "+ maxMinute + " "+ FmtMessage.getMessage('js.travel.minute'));
		}
	}
	
}


function filterSliderDepartureArrTimeList(minHour, maxHour) {
	return function(index){
		var farrdate = parseInt($(this).attr("farrdate").substring(0,2));
		
		if(!isNaN(farrdate) && farrdate == 0)
			farrdate = parseInt($(this).attr("farrdate").substring(1,2));
		
		if(!isNaN(farrdate)) {
			
			var chkMinute = parseInt($(this).attr("farrdate").substring(3,5));									//check minute
			if(chkMinute > 0 && farrdate < parseInt(minHour - 1) || farrdate > parseInt(maxHour + 1)) {			//check minute
				$(this).next().andSelf().attr("data-visible","false");
			} else if(farrdate < parseInt(minHour) || farrdate > parseInt(maxHour)) {
				$(this).next().andSelf().attr("data-visible","false");
			}
		}
	}
}

function filterSliderTravelTimesList(minTime, maxTime) {
	return function(index){
		if(!($(this).attr("flighttime") >= minTime && $(this).attr("flighttime") <= maxTime)){
			$(this).next().andSelf().attr("data-visible","false");
		}
	}
}

function filterSliderReturnDepTime(minHour, maxHour) {	

	$flightList.each(function(index) {
		
		var fdepdate = parseInt($(this).attr("rfdepdate").substring(0,2));
		
		if(!isNaN(fdepdate) && fdepdate == 0)
			fdepdate = parseInt($(this).attr("rfdepdate").substring(1,2));
		
		if(!isNaN(fdepdate)) {
			
			var chkMinute = parseInt($(this).attr("rfdepdate").substring(3,5));									//check minute
			if(chkMinute > 0 && fdepdate < parseInt(minHour - 1) || fdepdate > parseInt(maxHour + 1)) {			//check minute
				$(this).next().andSelf().attr("data-visible","false");
			} else if(fdepdate < parseInt(minHour) || fdepdate > parseInt(maxHour)) {
				$(this).next().andSelf().attr("data-visible","false");
			}
		}
	});	
	
	$flightListRet.each(filterSliderDepartureDepTimeList(minHour, maxHour));	
}

function filterSliderReturnArrTime(minHour, maxHour) {

	$flightList.each(function(index) {
		
		var farrdate = parseInt($(this).attr("rfarrdate").substring(0,2));
		
		if(!isNaN(farrdate) && farrdate == 0)
			farrdate = parseInt($(this).attr("rfarrdate").substring(1,2));
		
		if(!isNaN(farrdate)) {
			
			var chkMinute = parseInt($(this).attr("rfarrdate").substring(3,5));									//check minute
			if(chkMinute > 0 && farrdate < parseInt(minHour - 1) || farrdate > parseInt(maxHour + 1)) {			//check minute
				$(this).next().andSelf().attr("data-visible","false");
			} else if(farrdate < parseInt(minHour) || farrdate > parseInt(maxHour)) {
				$(this).next().andSelf().attr("data-visible","false");
			}
		}
	});
	
	$flightListRet.each(filterSliderDepartureArrTimeList(minHour, maxHour));
}


function resetFilterLayover() {
	$('#filterByTransfer0').prop('checked', true);
	$('#filterByTransfer1').prop('checked', true);
	$('#filterByTransfer2').prop('checked', true);
	
	$('#resetFilterLayover').hide();
	searchFilter();
}

function resetFilterReturnLayover() {
	$('#filterByReturnTransfer0').prop('checked', true);
	$('#filterByReturnTransfer1').prop('checked', true);
	$('#filterByReturnTransfer2').prop('checked', true);
	
	$('#resetFilterReturnLayover').hide();
	searchFilter();
}

function resetFilterTimeDpr() {
	$("#slider-range1").slider("option", "values", [0,24]);
	$("#dprDepartureTimes").val("00:00 - 24:00");
	$("#slider-range2").slider("option", "values", [0,24]);
	$("#dprArrivalTimes").val("00:00 - 24:00");
	
	var depTravelTimes = getTravelTimes($flightListDep, "departure"); 
	var minDepTravelTime =Math.min.apply(Math, depTravelTimes);
	var maxDepTravelTime =Math.max.apply(Math, depTravelTimes);
	$("#slider-range5").slider("option", "values", [minDepTravelTime, maxDepTravelTime]);
	writeSliderValues(minDepTravelTime, maxDepTravelTime,"departure");
	$('#resetFilterTimeDpr').hide();
	searchFilter();
}

function resetFilterTimeRtn() {
	$("#slider-range3").slider("option", "values", [0,24]);
	$("#rtnDepartureTimes").val("00:00 - 24:00");
	$("#slider-range4").slider("option", "values", [0,24]);
	$("#rtnArrivalTimes").val("00:00 - 24:00");
	var returnTravelTimes = getTravelTimes($flightListRet, "return");
	var minRetTravelTime =Math.min.apply(Math, returnTravelTimes);
	var maxRetTravelTime =Math.max.apply(Math, returnTravelTimes);
	$("#slider-range6").slider("option", "values", [minRetTravelTime, maxRetTravelTime]);
	writeSliderValues(minRetTravelTime, maxRetTravelTime,"return");
	$('#resetFilterTimeRtn').hide();
	searchFilter();
}

function resetFilterAirport() {
	$('.searchDepAirport').prop('checked', true);
	$('.searchArrAirport').prop('checked', true);
	$('.searchStopAirport').prop('checked', true);
	
	$('#resetFilterAirport').hide();
	searchFilter();
}

function resetFilterClass() {
	
	$('.searchClassFilter').prop('checked', true);	
	$('#resetFilterClass').hide();
	searchFilter();
}

function resetFilterAirline() {
	$('.searchFilterAirline').prop('checked', true);
	$('.searchFilterAirline').prop('checked', true);
	
	$('#resetFilterAirline').hide();
	searchFilter();
}

function resetAllFilterInputs(){
	
	$(".filterSlider").data("noFiltering",true);
	
	$('#filterByTransfer0').prop('checked', true);
	$('#filterByTransfer1').prop('checked', true);
	$('#filterByTransfer2').prop('checked', true);
	$('#resetFilterLayover').hide();
	
	$('#filterByReturnTransfer0').prop('checked', true);
	$('#filterByReturnTransfer1').prop('checked', true);
	$('#filterByReturnTransfer2').prop('checked', true);
	$('#resetFilterReturnLayover').hide();
	
	$("#slider-range1").slider("option", "values", [0,24]);
	$("#dprDepartureTimes").val("00:00 - 24:00");
	$("#slider-range2").slider("option", "values", [0,24]);
	$("#dprArrivalTimes").val("00:00 - 24:00");	
	$('#resetFilterTimeDpr').hide();
	
	if ($flightListRet.size() > 0) {
		$("#slider-range3").slider("option", "values", [0,24]);
		$("#rtnDepartureTimes").val("00:00 - 24:00");
		$("#slider-range4").slider("option", "values", [0,24]);
		$("#rtnArrivalTimes").val("00:00 - 24:00");	
		$('#resetFilterTimeRtn').hide();
	}
	
	$('.searchDepAirport').prop('checked', true);
	$('.searchStopAirport').prop('checked', true);
	$('.searchArrAirport').prop('checked', true);	
	$('#resetFilterAirport').hide();
	
	$('.searchClassFilter').prop('checked', true);	
	$('#resetFilterClass').hide();
	
	$('.searchFilterAirline').prop('checked', true);
	$('.searchFilterAirline').prop('checked', true);	
	$('#resetFilterAirline').hide();
	
	$(".filterSlider").data("noFiltering",false);
}

function unselectAllFilterAirline() {
	$('.searchFilterAirline').attr('checked', false);
	$('#resetFilterAirline').show();
	searchFilter();
}

function sort(id) {
 	var mylist = $('#'+id);
 	var listitems = mylist.children('li:not(.liheader)').get();
 	listitems.sort(function(a, b) {
 	   return $(a).text().toUpperCase().localeCompare($(b).text().toUpperCase());
 	})
 	$.each(listitems, function(idx, itm) { mylist.append(itm); });
 	$( document ).trigger( "flight_filter_event");
 }